export default `
	headline
	links {
		... on LinksItem {
			itemTitle
			itemUrl
			itemPage {
				... on Pages {
					uri
					teasers {
						...on TeasersItem {
							teaserSquare {
								filename
								height
								id
								size
								url(transform:teaserSquare)
								width
							}
							teaserPortrait {
								filename
								height
								id
								size
								url(transform:card)
								width
							}
						}
					}
				}
			}
		}
	}
`;
